var alertHistoryList = {
	caption: "Alert History List",
	noResultsMessage: "No results found",
	actions: "Actions",
	alert: {
		date: "Alert date",
		time: "Time",
		trigger: "Trigger",
		limitType: "Limit type",
		limitAbove: "Upper limit",
		limitBelow: "Lower limit"
	},
	security: {
		name: "Name",
		isin: "ISIN",
		lastPrice: "Last price",
		lastPriceDateTime: "Date/Time",
		assetClass: "Asset class",
		exchange: "Exchange"
	}
};
var en = {
	alertHistoryList: alertHistoryList
};

export { alertHistoryList, en as default };
